import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, union_type, record_type, string_type, option_type, array_type, bool_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Tickets_AttachmentForm_$reflection, Tickets_AttachmentForm, Tickets_HideAttachmentForm_$reflection, Tickets_HideAttachmentForm, Tickets_AttachmentMeta, GenericResponse_$reflection, Tickets_AttachmentMeta_$reflection } from "../Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { sortBy, map, append } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { corsProps, testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, item as item_1, length, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { some, unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableBody, IconButton, TableHead, TableCell, TableRow, Table, Skeleton, DialogContentText, DialogActions, Button, DialogContent, Checkbox, FormControlLabel, TextField, Typography, DialogTitle, Dialog } from "@mui/material";
import { empty as empty_1, map as map_2, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { wrapTooltip, SnackError, loadingIndicatorSmall, errorBanner } from "../ViewHelpers.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import { useResponsive } from "../Utils.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { sectionHeader } from "../TicketHelpers.js";
import { toDateAndTimeStr } from "../Locale.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import Delete from "@mui/icons-material/Delete";
import { compare } from "../fable_modules/fable-library-js.4.24.0/Date.js";

class Model extends Record {
    constructor(TicketId, CanCustomerEdit, CanAdminEdit, Attachments, UploadForm, DeleteForm, ErrorMsg) {
        super();
        this.TicketId = (TicketId | 0);
        this.CanCustomerEdit = CanCustomerEdit;
        this.CanAdminEdit = CanAdminEdit;
        this.Attachments = Attachments;
        this.UploadForm = UploadForm;
        this.DeleteForm = DeleteForm;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.TicketAttachments.Model", [], Model, () => [["TicketId", int32_type], ["CanCustomerEdit", bool_type], ["CanAdminEdit", bool_type], ["Attachments", option_type(array_type(Tickets_AttachmentMeta_$reflection()))], ["UploadForm", bool_type], ["DeleteForm", option_type(Tickets_AttachmentMeta_$reflection())], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AttachmentsResponse", "ToggleUploadForm", "AttachmentAdded", "VisibilityResponse", "ToggleDeleteForm", "AttachmentDeleted", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.TicketAttachments.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Tickets_AttachmentMeta_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Tickets_AttachmentMeta_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", bool_type]], [["Item", Tickets_AttachmentMeta_$reflection()]], [["Item1", union_type("Microsoft.FSharp.Core.FSharpResult`2", [GenericResponse_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", GenericResponse_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])], ["Item2", int32_type], ["Item3", bool_type]], [["Item", option_type(Tickets_AttachmentMeta_$reflection())]], [["Item", int32_type]], []]);
}

function init(ticketId, canCustomerEdit, canAdminEdit) {
    return new Model(ticketId, canCustomerEdit, canAdminEdit, undefined, false, undefined, undefined);
}

function update(locale, model, msg) {
    let matchValue_1, array_1;
    switch (msg.tag) {
        case 1:
            return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, model.Attachments, msg.fields[0], model.DeleteForm, model.ErrorMsg);
        case 2: {
            const x_2 = msg.fields[0];
            const matchValue = model.Attachments;
            if (matchValue != null) {
                return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, append(matchValue, [x_2]), false, model.DeleteForm, model.ErrorMsg);
            }
            else {
                return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, [x_2], false, model.DeleteForm, model.ErrorMsg);
            }
        }
        case 3: {
            const res_1 = msg.fields[0];
            if (res_1.tag === 0) {
                const x_3 = res_1.fields[0];
                if (x_3.Result !== "success") {
                    return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, model.Attachments, model.UploadForm, model.DeleteForm, x_3.Message);
                }
                else {
                    return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, (matchValue_1 = model.Attachments, (matchValue_1 != null) ? map((z) => {
                        if (z.Id === msg.fields[1]) {
                            return new Tickets_AttachmentMeta(z.Id, msg.fields[2], z.Filename, z.Desc, z.Uploaded, z.UploadedBy);
                        }
                        else {
                            return z;
                        }
                    }, matchValue_1) : undefined), model.UploadForm, model.DeleteForm, model.ErrorMsg);
                }
            }
            else {
                const err_1 = res_1.fields[0];
                return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, model.Attachments, model.UploadForm, model.DeleteForm, (err_1.tag === 2) ? (((err_1.fields[0].status) === 401) ? locale.t("TicketAttachment.MissingPermission") : locale.t("TicketAttachment.VisibilityFailed")) : locale.t("TicketAttachment.VisibilityFailed"));
            }
        }
        case 4:
            return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, model.Attachments, model.UploadForm, msg.fields[0], model.ErrorMsg);
        case 5: {
            const matchValue_2 = model.Attachments;
            if (matchValue_2 != null) {
                return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, (array_1 = matchValue_2, array_1.filter((z_1) => (z_1.Id !== msg.fields[0]))), model.UploadForm, undefined, model.ErrorMsg);
            }
            else {
                return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, model.Attachments, model.UploadForm, undefined, model.ErrorMsg);
            }
        }
        case 6:
            return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, model.Attachments, model.UploadForm, model.DeleteForm, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                const err = res.fields[0];
                return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, model.Attachments, model.UploadForm, model.DeleteForm, (err.tag === 2) ? (((err.fields[0].status) === 401) ? locale.t("TicketAttachment.FetchUnauthorized") : locale.t("TicketAttachment.FetchFailed")) : locale.t("TicketAttachment.FetchFailed"));
            }
            else {
                return new Model(model.TicketId, model.CanCustomerEdit, model.CanAdminEdit, res.fields[0], model.UploadForm, model.DeleteForm, model.ErrorMsg);
            }
        }
    }
}

function fetchAttachments(ticketId, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Tickets_AttachmentMeta_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/tickets/attachments/${ticketId}`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tickets_AttachmentMeta_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(0, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function toggleVisibility(attachmentId, isHidden, dispatch) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let data, decoder, data_1, caseStrategy_3, extra_3;
        const req = new Tickets_HideAttachmentForm(attachmentId, isHidden);
        return ((data = some(Auto_generateBoxedEncoder_437914C6(Tickets_HideAttachmentForm_$reflection(), undefined, undefined, undefined)(req)), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = data, (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/tickets/attachment/visibility", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })())))))).then((_arg_2) => {
            dispatch(new Message(3, [_arg_2, attachmentId, isHidden]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

function UploadForm(uploadFormInputProps) {
    let elements_2, children, elems_3, children_1;
    const onClose = uploadFormInputProps.onClose;
    const canAdminEdit = uploadFormInputProps.canAdminEdit;
    const ticketId = uploadFormInputProps.ticketId;
    const f = new Tickets_AttachmentForm(ticketId, "", "", "", false);
    const patternInput = reactApi.useState(f);
    const updateForm = patternInput[1];
    const attachmentForm = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrorMsg = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const docSelected = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setProcessing = patternInput_3[1];
    const ctx = reactApi.useContext(ctx_1);
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("Document.Upload")]]), (children = singleton_1(createElement("div", createObj(ofArray([["style", {
        minWidth: 350,
        maxWidth: 500,
    }], (elems_3 = toList(delay(() => append_1(singleton(errorBanner(patternInput_1[0], () => {
        setErrorMsg(undefined);
    })), delay(() => {
        let elems_2;
        return append_1(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
        }], (elems_2 = toList(delay(() => {
            let elems;
            return append_1(singleton(createElement("label", createObj(ofArray([["style", {
                cursor: "pointer",
                textAlign: "center",
                marginBottom: 5,
            }], (elems = [MuiHelpers_createElement(Typography, [["style", {
                textDecorationLine: "underline",
            }], ["children", !docSelected ? ctx.Locale.t("Document.ChooseFile") : ctx.Locale.t("Document.ChooseOtherFile")]]), createElement("input", {
                type: "file",
                style: {
                    display: "none",
                },
                onChange: (ev) => {
                    const fileList = ev.target.files;
                    if (!(fileList == null)) {
                        const x_2 = toList(delay(() => map_2((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1))));
                        try {
                            if (length(x_2) > 0) {
                                const file = item_1(0, x_2);
                                const filename = file.name;
                                const reader = new FileReader();
                                reader.addEventListener("load", (_arg_6) => {
                                    const content = reader.result;
                                    patternInput_2[1](true);
                                    updateForm(new Tickets_AttachmentForm(attachmentForm.TicketId, attachmentForm.Desc, filename, content, attachmentForm.IsHidden));
                                });
                                reader.readAsDataURL(file);
                            }
                        }
                        catch (matchValue_1) {
                        }
                    }
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (!docSelected ? singleton(createElement("span", {
                style: {
                    fontSize: 0.8 + "rem",
                    marginBottom: 10,
                },
                children: ctx.Locale.t("Document.NoFileSelected"),
            })) : singleton(createElement("span", {
                style: {
                    marginBottom: 10,
                    fontStyle: "italic",
                    fontSize: 0.8 + "rem",
                },
                children: reactApi.Children.toArray([attachmentForm.Filename]),
            })))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append_1(singleton(MuiHelpers_createElement(TextField, [["style", {
            marginBottom: 10,
        }], ["required", true], ["fullWidth", true], ["onChange", (e) => {
            updateForm(new Tickets_AttachmentForm(attachmentForm.TicketId, e.target.value, attachmentForm.Filename, attachmentForm.Content, attachmentForm.IsHidden));
        }], ["label", ctx.Locale.t("SparePart.Description")], ["defaultValue", attachmentForm.Desc], ["size", "small"], ["variant", "outlined"]])), delay(() => (canAdminEdit ? singleton(MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "end"], ["label", ctx.Locale.t("TicketAttachment.Hide")], ["control", MuiHelpers_createElement(Checkbox, [["checked", attachmentForm.IsHidden], ["onChange", (e_1) => {
            updateForm(new Tickets_AttachmentForm(attachmentForm.TicketId, attachmentForm.Desc, attachmentForm.Filename, attachmentForm.Content, e_1.target.checked));
        }], ["color", "primary"], ["id", "checkbox-is-hidden"]])]])) : empty_1())))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (patternInput_3[0] ? singleton(loadingIndicatorSmall()) : append_1(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_7) => {
        onClose(undefined);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["disabled", !docSelected ? true : (attachmentForm.Content.length === 0)], ["children", ctx.Locale.t("Document.Upload")], ["onClick", (_arg_8) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let body, decoder, data_1, caseStrategy_3, extra_3;
            if (attachmentForm.Content.length > 0) {
                setProcessing(true);
                return ((body = Auto_generateBoxedEncoder_437914C6(Tickets_AttachmentForm_$reflection(), undefined, undefined, undefined)(attachmentForm), (decoder = Auto_generateBoxedDecoder_Z6670B51(Tickets_AttachmentMeta_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                    let properties_2;
                    try {
                        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                        const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/tickets/attachment", properties_3).then((_arg) => {
                            let response_1, decoder_1_1;
                            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Tickets_AttachmentMeta_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                let matchValue;
                                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                        }))));
                        return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                    }
                    catch (exn) {
                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                    }
                })())))))).then((_arg_2) => {
                    const res = _arg_2;
                    if (res.tag === 1) {
                        const err = res.fields[0];
                        setErrorMsg((err.tag === 2) ? (((err.fields[0].status) === 401) ? ctx.Locale.t("TicketAttachment.MissingPermission") : (((err.fields[0].status) === 413) ? ctx.Locale.t("TicketAttachment.TooLarge") : ctx.Locale.t("TicketAttachment.UploadFailed"))) : ctx.Locale.t("TicketAttachment.UploadFailed"));
                        setProcessing(false);
                        return Promise.resolve();
                    }
                    else {
                        onClose(res.fields[0]);
                        return Promise.resolve();
                    }
                });
            }
            else {
                return Promise.resolve();
            }
        }));
        pr_1.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function AttachmentDeleteForm(attachmentDeleteFormInputProps) {
    let elements_2, children, children_1;
    const onClose = attachmentDeleteFormInputProps.onClose;
    const x = attachmentDeleteFormInputProps.x;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(false);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("TicketAttachment.Delete")]]), (children = ofArray([MuiHelpers_createElement(DialogContentText, [["children", ctx.Locale.t("TicketAttachment.DeleteDesc")]]), errorBanner(patternInput_1[0], () => {
        setErrMsg(undefined);
    })]), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (patternInput[0] ? singleton(loadingIndicatorSmall()) : append_1(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_6) => {
        onClose(false);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", ctx.Locale.t("Delete")], ["onClick", (_arg_7) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            setProcessing(true);
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/tickets/attachment/${x.Id}`, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 0) {
                    const x_2 = res.fields[0];
                    if (x_2.Result === "success") {
                        onClose(true);
                        return Promise.resolve();
                    }
                    else {
                        setProcessing(false);
                        setErrMsg(x_2.Message);
                        return Promise.resolve();
                    }
                }
                else {
                    setProcessing(false);
                    setErrMsg(ctx.Locale.t("TicketAttachment.DeleteFailed"));
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function drawLoading() {
    let elems;
    const loadingIndicator = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
        width: 100 + "%",
        height: 20,
    }]]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems = [loadingIndicator(), loadingIndicator(), loadingIndicator()], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

/**
 * Component for fetching, displaying and editing a tickets attachments
 */
export function Attachments(attachmentsInputProps) {
    let elems_10, elems_9;
    const canAdminEdit = attachmentsInputProps.canAdminEdit;
    const canCustomerEdit = attachmentsInputProps.canCustomerEdit;
    const ticketId = attachmentsInputProps.ticketId;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init(ticketId, canCustomerEdit, canAdminEdit);
    patternInput = reactApi.useReducer((model, msg) => update(ctx.Locale, model, msg), arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const responsive = useResponsive(undefined);
    const isBig = (responsive === "wideScreen") ? true : (responsive === "desktop");
    useEffectOnce(() => {
        fetchAttachments(ticketId, dispatch);
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_10 = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(6, []));
        },
    }), sectionHeader(ctx.Locale.t("TicketAttachment.Attachments")), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        padding: 5,
        border: (((1 + "px ") + "solid") + " ") + "#dedede",
    }], (elems_9 = toList(delay(() => {
        const matchValue = model_1.Attachments;
        if (matchValue != null) {
            const attachments = matchValue;
            return append_1(model_1.UploadForm ? singleton(createElement(UploadForm, {
                ticketId: ticketId,
                canAdminEdit: model_1.CanAdminEdit,
                onClose: (newAttachment) => {
                    if (newAttachment != null) {
                        dispatch(new Message(2, [newAttachment]));
                    }
                    else {
                        dispatch(new Message(1, [false]));
                    }
                },
            })) : empty_1(), delay(() => {
                let matchValue_1, df;
                return append_1((matchValue_1 = model_1.DeleteForm, (matchValue_1 != null) ? ((df = matchValue_1, singleton(createElement(AttachmentDeleteForm, {
                    x: df,
                    onClose: (didDelete) => {
                        if (!didDelete) {
                            dispatch(new Message(4, [undefined]));
                        }
                        else {
                            dispatch(new Message(5, [df.Id]));
                        }
                    },
                })))) : (empty_1())), delay(() => append_1((attachments.length === 0) ? singleton(MuiHelpers_createElement(Typography, [["variant", "caption"], ["children", ctx.Locale.t("TicketAttachment.NoAttachments")]])) : empty_1(), delay(() => {
                    let elements_7, children, elements, children_5;
                    return append_1(singleton(MuiHelpers_createElement(Table, [["size", "small"], (elements_7 = [(children = singleton_1(MuiHelpers_createElement(TableRow, [(elements = toList(delay(() => (isBig ? append_1(singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("Date")]])), delay(() => append_1(singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("TicketAttachment.FileName")]])), delay(() => append_1(singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("TicketAttachment.AddedBy")]])), delay(() => append_1(singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("SparePart.Description")]])), delay(() => append_1(singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("TicketAttachment.Hide")]])), delay(() => singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("TicketAttachment.Delete")]])))))))))))) : append_1(singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("TicketAttachment.FileName")]])), delay(() => append_1(singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("TicketAttachment.Hide")]])), delay(() => singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("TicketAttachment.Delete")]]))))))))), ["children", reactApi.Children.toArray(Array.from(elements))])])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_5 = map((a_2) => {
                        let matchValue_2;
                        const canDelete = model_1.CanAdminEdit ? true : (a_2.UploadedBy.AccountId === ((matchValue_2 = ctx.Session, (matchValue_2 != null) ? matchValue_2.UserId : -1)));
                        const children_4 = toList(delay(() => append_1(isBig ? singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["children", toDateAndTimeStr(ctx.DateFnsLocale, a_2.Uploaded)]])) : empty_1(), delay(() => {
                            let elements_2;
                            return append_1(singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], (elements_2 = [createElement("a", {
                                className: join(" ", ["text-overflow"]),
                                style: {
                                    display: "inline-block",
                                    userSelect: "none",
                                    maxWidth: 40 + "ch",
                                },
                                title: a_2.Filename,
                                href: `/api/tickets/attachments/download/${a_2.Id}`,
                                target: "_blank",
                                children: a_2.Filename,
                            })], ["children", reactApi.Children.toArray(Array.from(elements_2))])])), delay(() => append_1(isBig ? singleton(MuiHelpers_createElement(TableCell, [["className", join(" ", ["text-overflow"])], ["style", {
                                maxWidth: 20 + "ch",
                            }], ["title", a_2.UploadedBy.Email], ["size", "small"], ["variant", "body"], ["children", a_2.UploadedBy.Email]])) : empty_1(), delay(() => append_1(isBig ? singleton(MuiHelpers_createElement(TableCell, [["className", join(" ", ["text-overflow"])], ["style", {
                                maxWidth: 20 + "ch",
                            }], ["title", a_2.Desc], ["size", "small"], ["variant", "body"], ["children", a_2.Desc]])) : empty_1(), delay(() => {
                                let elements_3;
                                return append_1(model_1.CanAdminEdit ? singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], (elements_3 = toList(delay(() => {
                                    let props_17, props_19;
                                    return !isBig ? singleton(MuiHelpers_createElement(IconButton, [["size", "small"], ["children", a_2.Hidden ? ((props_17 = {
                                        style: {
                                            color: "#FF8C00",
                                        },
                                    }, react.createElement(VisibilityOff, props_17))) : ((props_19 = {}, react.createElement(Visibility, props_19)))], ["onClick", (_arg_2) => {
                                        toggleVisibility(a_2.Id, !a_2.Hidden, dispatch);
                                    }]])) : singleton(MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("TicketAttachment.Hide")], ["checked", a_2.Hidden], ["onChange", (e) => {
                                        toggleVisibility(a_2.Id, e.target.checked, dispatch);
                                    }], ["control", MuiHelpers_createElement(Checkbox, [["style", {
                                        padding: 0,
                                        marginRight: 5,
                                    }], ["size", "small"], ["color", "primary"]])]]));
                                })), ["children", reactApi.Children.toArray(Array.from(elements_3))])])) : empty_1(), delay(() => {
                                    let elements_4, child, props_25;
                                    return canDelete ? singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["padding", "checkbox"], ["style", {
                                        maxWidth: 30,
                                        width: 30,
                                    }], (elements_4 = [(child = MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_25 = {}, react.createElement(Delete, props_25))], ["onClick", (_arg_3) => {
                                        dispatch(new Message(4, [a_2]));
                                    }]]), wrapTooltip(ctx.Locale.t("Delete"), child))], ["children", reactApi.Children.toArray(Array.from(elements_4))])])) : empty_1();
                                }));
                            }))))));
                        }))));
                        return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_4))]]);
                    }, sortBy((a_1) => a_1.Uploaded, attachments, {
                        Compare: compare,
                    })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_5))]]))], ["children", reactApi.Children.toArray(Array.from(elements_7))])])), delay(() => {
                        let elems_8;
                        return model_1.CanAdminEdit ? singleton(createElement("div", createObj(ofArray([["style", {
                            marginTop: 10,
                        }], (elems_8 = [MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", ctx.Locale.t("Document.Upload")], ["onClick", (_arg_4) => {
                            dispatch(new Message(1, [true]));
                        }]])], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty_1();
                    }));
                }))));
            }));
        }
        else {
            return singleton(drawLoading());
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

